import React from 'react';
import './ReviewProduct.css';
import './CartPreview.css'
import { useDispatch } from 'react-redux'
import { cartData, removeFromCart } from '../../features/cart/cartSlice';
import { previousCart } from '../../driver';
import { useGetproductsQuery } from '../../features/api/apiSlice';
import '../../spinner.css'
const ReviewProduct = ({ cartData: stateCartData }) => {
    const dispatch = useDispatch();

    const { data: products, isLoading, isError } = useGetproductsQuery()

    const handleRemoveFromCart = (product) => {
        dispatch(removeFromCart(product?.uniqueId));
        dispatch(cartData(previousCart(products)));
    }
    // Describe what to do render
    let content = null;

    if (isLoading) content = <div className="loading">Loading&#8230;</div>;
    

    if (!isLoading && !isError && products.length > 0) {
        content = stateCartData?.map((product, index) => (
            <div className={'row'} key={index}>
                <div className="col-12">
                    <ul className="cart-items">
                        <li className="cart-item">
                            <img alt='' className="product-image" src={product?.url} />
                            <div className="product-info">
                                <p className="product-name">{product?.name}</p>
                                <p className="product-price">৳{product?.price}</p>
                            </div>
                            <div className="product-total">
                                <p className="quantity">
                                    {`${product?.orderQuantity > 1 ? "Qty:" : "No."
                                        } ${product?.orderQuantity}`}
                                </p>
                                <p className="amount">৳{product?.orderQuantity * product?.price}</p>
                            </div>
                            <button
                                className="product-remove"
                                onClick={() => handleRemoveFromCart(product)}
                            >
                                ×
                            </button>
                        </li>
                    </ul>
                    <hr />
                </div>
            </div>
        ))
    }
    return (
        <div className='review-product'>
            <div className="row">
                <div className=" col-md-8 col-sm-7 col-lg-9">
                    <h6>Items Details ({stateCartData?.length} item)</h6>
                </div>
            </div>
            <hr />
            {
                content
            }
        </div>
    );
};

export default ReviewProduct;